import { ShipmentDeliveryAttachment } from '../models/shipment-delivery.attachment';

const WAYBILL_FILE_TYPES = new Set([
    'historical waybill',
    'waybill',
    'bayan waybill',
    'generated waybill'
]);

function normalize(value?: string | null): string {
    return String(value ?? '')
        .trim()
        .replace(/[_-]+/g, ' ')
        .toLowerCase();
}

function toMillis(value?: string | number | Date | null): number {
    if (value instanceof Date) {
        return value.getTime();
    }
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : 0;
    }
    const millis = value ? new Date(value).getTime() : NaN;
    return Number.isFinite(millis) ? millis : 0;
}

export function isHistoricalWaybillAttachment(attachment?: Partial<ShipmentDeliveryAttachment> | null): boolean {
    return normalize(attachment?.fileType) === 'historical waybill';
}

export function isWaybillAttachment(attachment?: Partial<ShipmentDeliveryAttachment> | null): boolean {
    const fileType = normalize(attachment?.fileType);
    if (WAYBILL_FILE_TYPES.has(fileType)) {
        return true;
    }
    return normalize(attachment?.fileName).includes('waybill');
}

export function hasWaybillAttachment(
    attachments?: Array<Partial<ShipmentDeliveryAttachment> | null> | null
): boolean {
    return (attachments ?? []).some(attachment => isWaybillAttachment(attachment));
}

export function latestHistoricalWaybillAttachment<T extends Partial<ShipmentDeliveryAttachment>>(
    attachments?: T[] | null
): T | undefined {
    return [...(attachments ?? [])]
        .filter(attachment => isHistoricalWaybillAttachment(attachment))
        .sort((left, right) => toMillis(right.creationDate) - toMillis(left.creationDate))[0];
}
